// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-tree-title {
  /* color: grey; */
  font-weight: normal;
}

.ant-tree .ant-tree-node-content-wrapper.ant-tree-node-selected {
  color: orange;
  background-color: white !important;
}

.ant-tree-node-content-wrapper {
  display: flex;
}

.ant-tree {
  color: grey;
}
`, "",{"version":3,"sources":["webpack://./../../libs/console/legacy-ce/src/lib/components/Services/Data/custom.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb","sourcesContent":[".ant-tree-title {\n  /* color: grey; */\n  font-weight: normal;\n}\n\n.ant-tree .ant-tree-node-content-wrapper.ant-tree-node-selected {\n  color: orange;\n  background-color: white !important;\n}\n\n.ant-tree-node-content-wrapper {\n  display: flex;\n}\n\n.ant-tree {\n  color: grey;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
